export default "__VITE_ASSET__lPi6DCV8__"